import React, { useEffect, useRef, useState } from 'react'
import App from '../LayoutMobile'
import { Config } from '../Common/Config'
import { Button, Card, Row, Col, DatePicker, Form, Input, InputNumber, message, Select, Slider, Spin, Tag, TimePicker, Tooltip, Typography } from 'antd'
import { CheckCircleOutlined, ClockCircleOutlined, EditOutlined, ThunderboltOutlined, WarningOutlined } from "@ant-design/icons";
import axios from 'axios';
import moment from 'moment';
import dayjs from "dayjs";
import { Editor } from '@tinymce/tinymce-react';
import { customDropdown } from '../Common/CommonFunction';
import './Other.css';
const { Title } = Typography;
const { Option } = Select;

const Other = () => {
    const [form] = Form.useForm();
    const [sembleForm] = Form.useForm();
    const [smsForm] = Form.useForm();
    const [emailForm] = Form.useForm();
    const [mobileForm] = Form.useForm();
    const [gtmForm] = Form.useForm();
    const [sessionForm] = Form.useForm();
    const [patientForm] = Form.useForm();
    const patientEditorRef = useRef(null);

    const [allClinicData, setallClinicData] = useState([])
    const [loader, setloader] = useState(false)
    const [isSubmittingLantum, setIsSubmittingLantum] = useState(false);
    const [isSubmittingSemble, setIsSubmittingSemble] = useState(false);
    const [isSubmittingSms, setIsSubmittingSms] = useState(false);
    const [isSubmittingEmail, setIsSubmittingEmail] = useState(false);
    const [isSubmittingMobile, setIsSubmittingMobile] = useState(false);
    const [isSubmittingGtm, setIsSubmittingGtm] = useState(false);
    const [isSubmittingTestEmail, setIsSubmittingTestEmail] = useState(false);
    const [isSubmittingTestSms, setIsSubmittingTestSms] = useState(false);
    const [isSubmittingSession, setIsSubmittingSession] = useState(false);
    const [isSubmittingPatient, setIsSubmittingPatient] = useState(false);
    const [isEditingPatient, setIsEditingPatient] = useState(false);
    const [patientConfig, setPatientConfig] = useState({ subject: "", body: "" });
    const [sessionConfig, setSessionConfig] = useState({
        duration_minutes: 7,
        warning_before_seconds: 30,
        extension_minutes: 5,
        max_extensions: 2,
    });
    const [selected, setSelected] = useState(null);
    const [messageApi, contextHolder] = message.useMessage();
    const [productCategoryData, setProductCategoryData] = useState([]);
    const [settingsData, setSettingsData] = useState({});
    const [editLantumSecret, setEditLantumSecret] = useState(false);
    const [editLantumClint, setEditLantumClint] = useState(false);
    const [editSmsApiKey, setEditSmsApiKey] = useState(false);
    const [editSmsApiSecret, setEditSmsApiSecret] = useState(false);
    const [editSmsJwtToken, setEditSmsJwtToken] = useState(false);
    const [editSembleAccessToken, setEditSembleAccessToken] = useState(false);
    const [datesms, setDatesms] = useState(null);
    const [dateemail, setDateemail] = useState(false);
    const hasFetched = useRef(false);

    useEffect(() => {
        if (!hasFetched.current) {
            productCategory()
            getSettings()
            getAllClinicData()
            hasFetched.current = true;
        }
    }, [])

    const getAllClinicData = async () => {
        setloader(true)
        try {
            const response = await axios.get(`${Config.url}clinic?per_page=-1`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            setallClinicData(response?.data?.data)
            hasFetched.current = false;
            setloader(false)
        } catch (error) {
            setloader(false)
            messageApi.error({
                type: 'error',
                content: error.response?.data?.message || error.message || "Something went wrong",
            });
        }
    }

    const productCategory = async () => {
        setloader(true)
        try {
            const response = await axios.get(`${Config.url}product-category/page/1`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            setProductCategoryData(response?.data?.data.data || []);
            setloader(false)
        } catch (error) {
            setloader(false)
            messageApi.error({
                type: 'error',
                content: error.response?.data?.message || error.message || "Something went wrong",
            });
        }
    }

    const getSettings = async () => {
        setloader(true)
        try {
            const response = await axios.get(`${Config.url}settings`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            // API returns response.data.data; booking_session may be a flat object
            // (per IOO-275) or a legacy array of {key_name, value} objects.
            setSettingsData(response?.data?.data || {});
            setloader(false)
        } catch (error) {
            setloader(false)
            messageApi.error({
                type: 'error',
                content: error.response?.data?.message || error.message || "Something went wrong",
            });
        }
    }

    // Lantum
    useEffect(() => {
        const lantumCredentials = settingsData.lantum &&
            Array.isArray(settingsData.lantum) &&
            settingsData.lantum.length > 0 &&
            Array.isArray(settingsData.lantum.find(item => item.key_name === "lantum.credentials")?.value)
            ? settingsData.lantum.find(item => item.key_name === "lantum.credentials").value[0]
            : {};
        form.setFieldsValue({
            client_id: lantumCredentials.client_id || "",
            client_secret: lantumCredentials.client_secret || "",
            token_url: lantumCredentials.token_url || "",
            audience: lantumCredentials.audience || "",
        });
    }, [settingsData]);

    // SMS
    useEffect(() => {
        const smsCredentials = settingsData.sms &&
            Array.isArray(settingsData.sms) &&
            settingsData.sms.length > 0 &&
            Array.isArray(settingsData.sms.find(item => item.key_name === "sms.credentials")?.value)
            ? settingsData.sms.find(item => item.key_name === "sms.credentials").value[0]
            : {};
        smsForm.setFieldsValue({
            api_key: smsCredentials.api_key || "",
            api_secret: smsCredentials.api_secret || "",
            jwt_token: smsCredentials.jwt_token || "",
        });
    }, [settingsData]);

    // Semble
    useEffect(() => {
        const sembleAccessToken =
            settingsData.semble &&
                Array.isArray(settingsData.semble) &&
                settingsData.semble.length > 0
                ? settingsData.semble.find(item => item.key_name === "semble.access_token")?.value || ""
                : "";
        sembleForm.setFieldsValue({
            accessToken: sembleAccessToken || "",
        });
    }, [settingsData]);

    // Email address for booking confirmations
    useEffect(() => {
        const emailUsername = settingsData.email &&
            Array.isArray(settingsData.email) &&
            settingsData.email.length > 0
            ? settingsData.email.find(item => item.key_name === "email.username")?.value || ""
            : "";
        emailForm.setFieldsValue({
            username: emailUsername || "",
        });
    }, [settingsData]);

    // Mobile number for booking confirmations
    useEffect(() => {
        const smsMobileNumber = settingsData.sms &&
            Array.isArray(settingsData.sms) &&
            settingsData.sms.length > 0
            ? settingsData.sms.find(item => item.key_name === "sms.mobile_number")?.value || ""
            : "";
        mobileForm.setFieldsValue({
            phone_number: smsMobileNumber || "",
        });
    }, [settingsData]);

    // Google Tag Manager
    useEffect(() => {
        const gtmCode = settingsData.gtm &&
            Array.isArray(settingsData.gtm) &&
            settingsData.gtm.length > 0
            ? settingsData.gtm.find(item => item.key_name === "gtm.code")?.value || ""
            : "";
        gtmForm.setFieldsValue({
            code: gtmCode || "",
        });
    }, [settingsData]);

    // Booking Session Settings — IOO-275 Part 1A
    // Supports both the new flat-object response { duration_seconds, warning_before_seconds, ... }
    // and the legacy array-of-{key_name,value} format for backwards compat.
    useEffect(() => {
        const bs = settingsData.booking_session;

        if (bs && !Array.isArray(bs) && typeof bs === 'object') {
            // ── New flat-object API response (IOO-275) ──
            const durSec = parseInt(bs.duration_seconds) || 420;
            const extSec = parseInt(bs.extension_duration_seconds) || 300;
            const warn = parseInt(bs.warning_before_seconds) || 30;
            const maxExt = parseInt(bs.max_extensions) || 2;
            const cfg = {
                duration_minutes: Math.round(durSec / 60),
                warning_before_seconds: warn,
                extension_minutes: Math.round(extSec / 60),
                max_extensions: maxExt,
            };
            sessionForm.setFieldsValue(cfg);
            setSessionConfig(cfg);
        } else if (bs && Array.isArray(bs) && bs.length > 0) {
            // ── Legacy array format ──
            // API may return key_name with OR without the "booking_session." prefix
            const getValue = (key) =>
                bs.find((s) => s.key_name === `booking_session.${key}` || s.key_name === key)?.value;
            const durSec = parseInt(getValue('duration_seconds')) || 420;
            const extSec = parseInt(getValue('extension_duration_seconds')) || 300;
            const warn = parseInt(getValue('warning_before_seconds')) || 30;
            const maxExt = parseInt(getValue('max_extensions')) || 2;
            const cfg = {
                duration_minutes: Math.round(durSec / 60),
                warning_before_seconds: warn,
                extension_minutes: Math.round(extSec / 60),
                max_extensions: maxExt,
            };
            sessionForm.setFieldsValue(cfg);
            setSessionConfig(cfg);
        } else {
            // Fallback defaults when booking_session group is absent
            const defaults = { duration_minutes: 7, warning_before_seconds: 30, extension_minutes: 5, max_extensions: 2 };
            sessionForm.setFieldsValue(defaults);
            setSessionConfig(defaults);
        }
    }, [settingsData]);

    // Hydrate patient settings
    useEffect(() => {
        const group = settingsData.patient;
        let accountSetupEmailVal = { subject: "", body: "" };
        if (group) {
            if (Array.isArray(group)) {
                const found = group.find(item => item.key_name === 'patient.account_setup_email');
                if (found) {
                    if (typeof found.value === 'string') {
                        try {
                            accountSetupEmailVal = JSON.parse(found.value);
                        } catch (e) {
                            console.error('Failed to parse patient.account_setup_email value JSON string:', e);
                        }
                    } else if (found.value && typeof found.value === 'object') {
                        accountSetupEmailVal = found.value;
                    }
                }
            } else if (typeof group === 'object') {
                const val = group['patient.account_setup_email'];
                if (val) {
                    if (typeof val === 'string') {
                        try {
                            accountSetupEmailVal = JSON.parse(val);
                        } catch (e) {
                            console.error('Failed to parse patient.account_setup_email value JSON string from object:', e);
                        }
                    } else if (typeof val === 'object') {
                        accountSetupEmailVal = val;
                    }
                }
            }
        }
        const config = {
            subject: accountSetupEmailVal?.subject || "",
            body: accountSetupEmailVal?.body || "",
        };
        patientForm.setFieldsValue(config);
        setPatientConfig(config);
    }, [settingsData, patientForm]);

    // ...rest of your handler functions (onFinishLantum, onFinishSemble, etc.)...

    const onFinishSendtestemail = async (values) => {
        setIsSubmittingTestEmail(true);
        // console.log("values",values)
        try {
            // const datePart = values.date.format("YYYY-MM-DD");
            // const datePart = moment(values.date).format("YYYY-MM-DD");
            const datePart = dayjs(values.date).format("YYYY-MM-DD");
            const timePart = moment(values.time).format("hh:mm");
            const finalDateTime = `${datePart} ${dateemail || timePart}`;
            const data = {
                product_category_id: values.Product,
                clinic_id: values.Clinic,
                start_time: finalDateTime,
                email: values.email
            };
            await axios.post(
                `${Config.url}send-test-email`,
                data,
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                }
            );
            messageApi.success("Test email sent successfully!");
        } catch (error) {
            messageApi.error(error.response?.data?.message || error.message || "Failed to send test email");
        } finally {
            setIsSubmittingTestEmail(false);
        }
    };

    const onFinishLantum = async (values) => {
        setIsSubmittingLantum(true);
        try {
            const response = await axios.put(
                `${Config.url}settings/${settingsData.lantum[0].id}`,
                {
                    key_name: "credentials",
                    value: [
                        {
                            client_id: values.client_id,
                            client_secret: values.client_secret,
                            token_url: values.token_url,
                            audience: values.audience,
                        }
                    ],
                    group_name: "lantum",
                    description: "Lantum credentials",
                    is_editable: true,
                    is_encrypted: settingsData.lantum[0]?.is_encrypted || false
                },
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                }
            );
            messageApi.success("Lantum credentials updated successfully!");
            setEditLantumClint(false);
            setEditLantumSecret(false);
            getSettings();
        } catch (error) {
            messageApi.error(error.response?.data?.message || error.message || "Failed to update Lantum credentials");
        } finally {
            setIsSubmittingLantum(false);
        }
    };

    const onFinishSemble = async (values) => {
        setIsSubmittingSemble(true);
        try {
            const sembleSetting = settingsData.semble?.find(item => item.key_name === "semble.access_token");
            const id = sembleSetting?.id;
            if (!id) {
                messageApi.error("Semble access token setting not found.");
                setloader(false);
                return;
            }
            await axios.put(
                `${Config.url}settings/${id}`,
                {
                    key_name: "access_token",
                    value: values.accessToken,
                    group_name: "semble",
                    description: "Semble access_token",
                    is_editable: true,
                    is_encrypted: sembleSetting?.is_encrypted || false
                },
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                }
            );
            messageApi.success("Semble access token updated successfully!");
            setEditSembleAccessToken(false);
            getSettings();
        } catch (error) {
            messageApi.error(error.response?.data?.message || error.message || "Failed to update Semble access token");
        } finally {
            setIsSubmittingSemble(false);
        }
    };

    const onFinishSms = async (values) => {
        setIsSubmittingSms(true);
        try {
            const smsSetting = settingsData.sms?.find(item => item.key_name === "sms.credentials");
            const id = smsSetting?.id;
            if (!id) {
                messageApi.error("SMS credentials setting not found.");
                setloader(false);
                return;
            }
            await axios.put(
                `${Config.url}settings/${id}`,
                {
                    key_name: "credentials",
                    value: [
                        {
                            api_key: values.api_key,
                            api_secret: values.api_secret,
                            jwt_token: values.jwt_token,
                        }
                    ],
                    group_name: "sms",
                    description: "sms api credentials",
                    is_editable: true,
                    is_encrypted: smsSetting?.is_encrypted || false
                },
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                }
            );
            messageApi.success("SMS credentials updated successfully!");
            setEditSmsApiKey(false);
            setEditSmsApiSecret(false);
            setEditSmsJwtToken(false);
            getSettings();
        } catch (error) {
            messageApi.error(error.response?.data?.message || error.message || "Failed to update SMS credentials");
        } finally {
            setIsSubmittingSms(false);
        }
    };

    const onFinishEmailUsername = async (values) => {
        setIsSubmittingEmail(true);
        try {
            const emailSetting = settingsData.email?.find(item => item.key_name === "email.username");
            const id = emailSetting?.id;
            if (!id) {
                messageApi.error("Email username setting not found.");
                setloader(false);
                return;
            }
            await axios.put(
                `${Config.url}settings/${id}`,
                {
                    key_name: "username",
                    value: values.username,
                    group_name: "email",
                    description: "SMTP username",
                    is_editable: true,
                    is_encrypted: emailSetting?.is_encrypted || false
                },
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                }
            );
            messageApi.success("Email address updated successfully!");
            getSettings();
        } catch (error) {
            messageApi.error(error.response?.data?.message || error.message || "Failed to update email address");
        } finally {
            setIsSubmittingEmail(false);
        }
    };

    const onFinishSmsMobileNumber = async (values) => {
        setIsSubmittingMobile(true);
        try {
            const smsMobileSetting = settingsData.sms?.find(item => item.key_name === "sms.mobile_number");
            const id = smsMobileSetting?.id;
            if (!id) {
                messageApi.error("Mobile number setting not found.");
                setloader(false);
                return;
            }
            await axios.put(
                `${Config.url}settings/${id}`,
                {
                    key_name: "mobile_number",
                    value: values.phone_number,
                    group_name: "sms",
                    description: "mobile no for booking confirmation sms",
                    is_editable: true,
                    is_encrypted: smsMobileSetting?.is_encrypted || false
                },
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                }
            );
            messageApi.success("Mobile number updated successfully!");
            getSettings();
        } catch (error) {
            messageApi.error(error.response?.data?.message || error.message || "Failed to update mobile number");
        } finally {
            setIsSubmittingMobile(false);
        }
    };

    const onFinishGtmCode = async (values) => {
        setIsSubmittingGtm(true);
        try {
            const gtmSetting = settingsData.gtm?.find(item => item.key_name === "gtm.code");
            const id = gtmSetting?.id;
            if (!id) {
                messageApi.error("GTM code setting not found.");
                return;
            }
            await axios.put(
                `${Config.url}settings/${id}`,
                {
                    key_name: "code",
                    value: values.code,
                    group_name: "gtm",
                    description: "GTM code",
                    is_editable: true,
                    is_encrypted: gtmSetting?.is_encrypted || false
                },
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                }
            );
            messageApi.success("GTM code updated successfully!");
            // getSettings();
        } catch (error) {
            messageApi.error(error.response?.data?.message || error.message || "Failed to update GTM code");
        } finally {
            setIsSubmittingGtm(false);
        }
    };

    // IOO-275 Part 1B — single group PUT endpoint
    const onFinishSessionSettings = async () => {
        setIsSubmittingSession(true);
        try {
            // Use sessionConfig as the single source of truth — it drives the
            // Tags and "Current config" bar, so the payload always matches the display.
            const payload = {
                duration_seconds: sessionConfig.duration_minutes * 60,
                warning_before_seconds: sessionConfig.warning_before_seconds,
                extension_duration_seconds: sessionConfig.extension_minutes * 60,
                max_extensions: sessionConfig.max_extensions,
            };

            await axios.put(
                `${Config.url}settings/group/booking_session`,
                payload,
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    },
                }
            );

            // sessionConfig is already current (it was the payload source), no update needed.
            messageApi.success('Booking session settings updated successfully!');
            getSettings(); // Re-fetch to stay in sync with backend
        } catch (e) {
            messageApi.error(e.response?.data?.message || e.message || 'Failed to update session settings');
        } finally {
            setIsSubmittingSession(false);
        }
    };

    const onFinishPatientSettings = async (values) => {
        setIsSubmittingPatient(true);
        try {
            const payload = {
                "patient.account_setup_email": {
                    subject: values.subject,
                    body: patientEditorRef.current ? patientEditorRef.current.getContent() : (values.body || ""),
                }
            };

            await axios.put(
                `${Config.url}settings/group/patient`,
                payload,
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    },
                }
            );

            messageApi.success('Patient email settings updated successfully!');
            setIsEditingPatient(false);
            getSettings(); // Re-fetch to sync with backend
        } catch (e) {
            messageApi.error(e.response?.data?.message || e.message || 'Failed to update patient settings');
        } finally {
            setIsSubmittingPatient(false);
        }
    };

    const onFinishSendTestSms = async (values) => {
        try {
            // const datePart = moment(values.date).format("YYYY-MM-DD");
            const datePart = dayjs(values.date).format("YYYY-MM-DD");
            const timePart = moment(values.time).format("HH:mm");
            const finalDateTime = `${datePart} ${datesms || timePart}`;
            let country_code = "";
            let mobile_number = values.phone_number;
            if (mobile_number.startsWith("+")) {
                const match = mobile_number.match(/^(\+\d{1,3})(\d{7,})$/);
                if (match) {
                    country_code = match[1];
                    mobile_number = match[2];
                }
            } else {
                country_code = "+44";
            }
            const data = {
                product_category_id: values.Product,
                clinic_id: values.Clinic,
                start_time: finalDateTime,
                mobile_number,
                country_code,
            };
            await axios.post(
                `${Config.url}send-test-sms`,
                data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                }
            );
            messageApi.success("Test SMS sent successfully!");
        } catch (error) {
            messageApi.error(error.response?.data?.message || error.message || "Failed to send test SMS");
        }
    };

    const onFinishFailed = errorInfo => { };

    const onChange = (date, dateString) => { };
    const onChangesms = (date, dateString) => { setDatesms(dateString) };
    const onChangeemail = (date, dateString) => { setDateemail(dateString) };

    const lantumCredentials = settingsData.lantum &&
        Array.isArray(settingsData.lantum) &&
        settingsData.lantum.length > 0 &&
        Array.isArray(settingsData.lantum.find(item => item.key_name === "lantum.credentials")?.value)
        ? settingsData.lantum.find(item => item.key_name === "lantum.credentials").value[0]
        : {};
    const sembleAccessToken =
        settingsData.semble &&
            Array.isArray(settingsData.semble) &&
            settingsData.semble.length > 0
            ? settingsData.semble.find(item => item.key_name === "semble.access_token")?.value || ""
            : {};
    const smsCredentials = settingsData.sms &&
        Array.isArray(settingsData.sms) &&
        settingsData.sms.length > 0 &&
        Array.isArray(settingsData.sms.find(item => item.key_name === "sms.credentials")?.value)
        ? settingsData.sms.find(item => item.key_name === "sms.credentials").value[0]
        : {};
    const emailUsername = settingsData.email &&
        Array.isArray(settingsData.email) &&
        settingsData.email.length > 0 ? settingsData.email.find(item => item.key_name === "email.username")?.value || "" : "";
    const smsMobileNumber = settingsData.sms &&
        Array.isArray(settingsData.sms) &&
        settingsData.sms.length > 0
        ? settingsData.sms.find(item => item.key_name === "sms.mobile_number")?.value || ""
        : "";
    const gtmCode = settingsData.gtm &&
        Array.isArray(settingsData.gtm) &&
        settingsData.gtm.length > 0
        ? settingsData.gtm.find(item => item.key_name === "gtm.code")?.value || ""
        : "";

    return (
        <App>
            {contextHolder}
            <div style={{ display: 'grid', margin: 'auto', alignItems: 'center', alignContent: 'center', justifyContent: 'center' }}>
                {loader ? <Spin spinning={loader} className="custom-spinner" size="large"></Spin> :
                    <>
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 40, gap: 30 }}>
                            <Spin className="custom-spinner" spinning={loader} size="large"></Spin>
                            <Card style={{ width: 460, textAlign: "center", borderRadius: 12 }}>
                                <div style={{ background: "#008385", color: "#fff", padding: "10px", borderRadius: "10px 10px 0 0", margin: 0, fontSize: 18 }}>
                                    Lantum credentials
                                </div>
                                <div style={{ marginTop: 20 }}>
                                    <Form
                                        form={form}
                                        name="lantum-credentials"
                                        onFinish={onFinishLantum}
                                        onFinishFailed={onFinishFailed}
                                        initialValues={{
                                            client_id: lantumCredentials.client_id || "",
                                            client_secret: lantumCredentials.client_secret || "",
                                            token_url: lantumCredentials.token_url || "",
                                            audience: lantumCredentials.audience || "",
                                        }}
                                    >
                                        <Form.Item
                                            label={null}
                                            name="client_id"
                                            rules={[{ required: true, message: 'Client ID is required' }]}
                                        >
                                            <Input
                                                disabled={!editLantumClint}
                                                placeholder='Client ID'
                                                suffix={
                                                    !editLantumClint ? (
                                                        <EditOutlined
                                                            style={{ color: '#008385' }}
                                                            onClick={() => {
                                                                form.setFieldsValue({ client_id: '' });
                                                                setEditLantumClint(true);
                                                            }}
                                                        />
                                                    ) : null
                                                }
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            label={null}
                                            name="client_secret"
                                            rules={[{ required: true, message: 'Client Secret is required' }]}
                                        >
                                            <Input
                                                disabled={!editLantumSecret}
                                                placeholder={'Client Secret'}
                                                suffix={
                                                    !editLantumSecret ? (
                                                        <EditOutlined
                                                            style={{ color: '#008385' }}
                                                            onClick={() => {
                                                                form.setFieldsValue({ client_secret: '' });
                                                                setEditLantumSecret(true);
                                                            }}
                                                        />
                                                    ) : null
                                                }
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            label={null}
                                            name="token_url"
                                            rules={[{ required: true, message: 'Token URL is required' }]}
                                        >
                                            <Input placeholder='Token URL' />
                                        </Form.Item>
                                        <Form.Item
                                            label={null}
                                            name="audience"
                                            rules={[{ required: true, message: 'Audience is required' }]}
                                        >
                                            <Input placeholder='Audience' />
                                        </Form.Item>
                                        <Form.Item label={null}>
                                            <Button type="primary" style={{ width: 215, backgroundColor: '#008385', height: 40 }} htmlType="submit" loading={isSubmittingLantum} disabled={isSubmittingLantum}>
                                                Submit
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                </div>
                            </Card>
                            <Card style={{ width: 460, textAlign: "center", borderRadius: 12 }}>
                                <div style={{ background: "#008385", color: "#fff", padding: "10px", borderRadius: "10px 10px 0 0", margin: 0, fontSize: 18 }}>
                                    Semble credentials
                                </div>
                                <div style={{ marginTop: 20 }}>
                                    <Form
                                        form={sembleForm}
                                        name="semble-credentials"
                                        initialValues={{ accessToken: sembleAccessToken }}
                                        onFinish={onFinishSemble}
                                        onFinishFailed={onFinishFailed}
                                        autoComplete="off"
                                    >
                                        <Form.Item
                                            label={null}
                                            name="accessToken"
                                            rules={[{ required: true, message: 'Please input your access token!' }]}
                                        >
                                            <Input
                                                disabled={!editSembleAccessToken}
                                                placeholder="Access Token"
                                                suffix={
                                                    !editSembleAccessToken ? (
                                                        <EditOutlined
                                                            style={{ color: '#008385' }}
                                                            onClick={() => {
                                                                sembleForm.setFieldsValue({ accessToken: '' });
                                                                setEditSembleAccessToken(true);
                                                            }}
                                                        />
                                                    ) : null
                                                }
                                            />
                                        </Form.Item>
                                        <Form.Item label={null}>
                                            <Button type="primary" style={{ width: 215, backgroundColor: '#008385', height: 40, marginTop: 50 }} htmlType="submit" loading={isSubmittingSemble} disabled={isSubmittingSemble}>
                                                Submit
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                </div>
                            </Card>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 40, gap: 30 }}>
                            <Card style={{ width: 460, textAlign: "center", borderRadius: 12 }}>
                                <div style={{ background: "#008385", color: "#fff", padding: "10px", borderRadius: "10px 10px 0 0", margin: 0, fontSize: 18 }}>
                                    SMS credentials
                                </div>
                                <div style={{ marginTop: 20 }}>
                                    <Form
                                        form={smsForm}
                                        name="sms-credentials"
                                        onFinish={onFinishSms}
                                        onFinishFailed={onFinishFailed}
                                        autoComplete="off"
                                        initialValues={{
                                            api_key: smsCredentials.api_key || "",
                                            api_secret: smsCredentials.api_secret || "",
                                            jwt_token: smsCredentials.jwt_token || "",
                                        }}
                                    >
                                        <Form.Item
                                            label={null}
                                            name="api_key"
                                            rules={[{ required: true, message: 'Api key is required' }]}
                                        >
                                            <Input
                                                disabled={!editSmsApiKey}
                                                placeholder="Api key"
                                                suffix={
                                                    !editSmsApiKey ? (
                                                        <EditOutlined
                                                            style={{ color: '#008385' }}
                                                            onClick={() => {
                                                                smsForm.setFieldsValue({ api_key: '' });
                                                                setEditSmsApiKey(true);
                                                            }}
                                                        />
                                                    ) : null
                                                }
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            label={null}
                                            name="api_secret"
                                            rules={[{ required: true, message: 'Api secret is required' }]}
                                        >
                                            <Input
                                                disabled={!editSmsApiSecret}
                                                placeholder="Api secret"
                                                suffix={
                                                    !editSmsApiSecret ? (
                                                        <EditOutlined
                                                            style={{ color: '#008385' }}
                                                            onClick={() => {
                                                                smsForm.setFieldsValue({ api_secret: '' });
                                                                setEditSmsApiSecret(true);
                                                            }}
                                                        />
                                                    ) : null
                                                }
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            label={null}
                                            name="jwt_token"
                                            rules={[{ required: true, message: 'Jwt token is required' }]}
                                        >
                                            <Input
                                                disabled={!editSmsJwtToken}
                                                placeholder="Jwt token"
                                                suffix={
                                                    !editSmsJwtToken ? (
                                                        <EditOutlined
                                                            style={{ color: '#008385' }}
                                                            onClick={() => {
                                                                smsForm.setFieldsValue({ jwt_token: '' });
                                                                setEditSmsJwtToken(true);
                                                            }}
                                                        />
                                                    ) : null
                                                }
                                            />
                                        </Form.Item>
                                        <Form.Item label={null}>
                                            <Button type="primary" style={{ width: 215, backgroundColor: '#008385', height: 40, marginTop: 50 }} htmlType="submit" loading={isSubmittingSms} disabled={isSubmittingSms}>
                                                Submit
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                </div>
                            </Card>
                            <Card style={{ width: 460, textAlign: "center", borderRadius: 12, padding: 0 }}>
                                <div style={{ background: "#008385", color: "#fff", padding: "10px", borderRadius: "10px 10px 0 0", margin: 0, fontSize: 18 }}>
                                    Email address for booking confirmations
                                </div>
                                <div style={{ marginTop: 20 }}>
                                    <Form
                                        form={emailForm}
                                        name="email-username"
                                        onFinish={onFinishEmailUsername}
                                        autoComplete="off"
                                    >
                                        <Form.Item
                                            label={null}
                                            name="username"
                                            rules={[{ required: true, message: 'Username is required' }]}
                                        >
                                            <Input placeholder='Username' />
                                        </Form.Item>
                                        <Form.Item label={null}>
                                            <Button type="primary" style={{ width: 215, backgroundColor: '#008385', height: 40 }} htmlType="submit" loading={isSubmittingEmail} disabled={isSubmittingEmail}>
                                                Submit
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                </div>
                            </Card>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 40, gap: 30 }}>
                            <Card style={{ width: 460, textAlign: "center", borderRadius: 12 }}>
                                <div style={{ background: "#008385", color: "#fff", padding: "10px", borderRadius: "10px 10px 0 0", margin: 0, fontSize: 18 }}>
                                    Mobile number for booking confirmations
                                </div>
                                <div style={{ marginTop: 20 }}>
                                    <Form
                                        form={mobileForm}
                                        name="sms-mobile-number"
                                        onFinish={onFinishSmsMobileNumber}
                                        onFinishFailed={onFinishFailed}
                                        autoComplete="off"
                                    >
                                        <Form.Item
                                            label={null}
                                            name="phone_number"
                                            rules={[{ required: true, message: 'Mobile number is required' }, {
                                                pattern: /^[0-9]+$/,
                                                message: "Only numeric values are allowed!",
                                            }, {
                                                pattern: /^07\d{9}$/,
                                                message: "Mobile number must be a valid UK mobile (11 digits, start with 07)",
                                            }
                                            ]}
                                        >
                                            <Input placeholder='Mobile number' />
                                        </Form.Item>
                                        <Form.Item label={null}>
                                            <Button type="primary" style={{ width: 215, backgroundColor: '#008385', height: 40 }} htmlType="submit" loading={isSubmittingMobile} disabled={isSubmittingMobile}>
                                                Submit
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                </div>
                            </Card>
                            <Card style={{ width: 460, textAlign: "center", borderRadius: 12 }}>
                                <div style={{ background: "#008385", color: "#fff", padding: "10px", borderRadius: "10px 10px 0 0", margin: 0, fontSize: 18 }}>
                                    Google tag manager
                                </div>
                                <div style={{ marginTop: 20 }}>
                                    <Form
                                        form={gtmForm}
                                        name="gtm-id"
                                        onFinish={onFinishGtmCode}
                                        onFinishFailed={onFinishFailed}
                                        autoComplete="off"
                                    >
                                        <Form.Item
                                            label={null}
                                            name="code"
                                            rules={[{ required: true, message: 'GTM ID is required' }]}
                                        >
                                            <Input placeholder='GTM id' />
                                        </Form.Item>
                                        <Form.Item label={null}>
                                            <Button type="primary" style={{ width: 215, backgroundColor: '#008385', height: 40 }} htmlType="submit" loading={isSubmittingGtm} disabled={isSubmittingGtm}>
                                                Submit
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                </div>
                            </Card>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 40, gap: 30 }}>
                            <Card style={{ width: 460, textAlign: "center", borderRadius: 12, padding: 0 }}>
                                <div style={{ background: "#008385", color: "#fff", padding: "10px", borderRadius: "10px 10px 0 0", margin: 0, fontSize: 18 }}>
                                    Send test email
                                </div>
                                <div style={{ marginTop: 20 }}>
                                    <Form
                                        name="basic"
                                        // initialValues={{ remember: true }}
                                        onFinish={onFinishSendtestemail}
                                        onFinishFailed={onFinishFailed}
                                        autoComplete="off"
                                    >
                                        <Row gutter={24}>
                                            <Col span={12}>
                                                <Form.Item
                                                    label={null}
                                                    name="Product"
                                                    rules={[{ required: true, message: 'Product is required' }]}
                                                >
                                                    <Select className="inputbox-custom-placeholder" placeholder="Product" style={{ width: '100%' }}>
                                                        {productCategoryData && productCategoryData.map((item) => {
                                                            return (
                                                                <Option key={item.product_category_id} value={item.product_category_id}>{item.name}</Option>
                                                            )
                                                        })
                                                        }
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item
                                                    label={null}
                                                    name="Clinic"
                                                    rules={[{ required: true, message: 'Username is required' }]}
                                                >
                                                    <Select className="inputbox-custom-placeholder" placeholder="Clinic" style={{ width: '100%' }}>
                                                        {loader == false && allClinicData.data && allClinicData.data.length && allClinicData.data.map((item) => {
                                                            return (
                                                                <Option key={item.id} value={item.id}>{item.name}</Option>
                                                            )
                                                        })
                                                        }
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row gutter={24}>
                                            <Col span={12}>
                                                <Form.Item
                                                    label={null}
                                                    name="date"
                                                    rules={[{ required: true, message: 'date is required' }]}
                                                >
                                                    <DatePicker style={{ width: '100%' }} />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item
                                                    label={null}
                                                    name="time"
                                                    rules={[{ required: true, message: 'Time is required' }]}
                                                >
                                                    <TimePicker style={{ width: '100%' }} />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Form.Item
                                            label={null}
                                            name="email"
                                            rules={[{ type: 'email', required: true, message: 'email is required' }]}
                                        >
                                            <Input placeholder='email' name='email' autoComplete="usernamedfsdfsdf" />
                                        </Form.Item>
                                        <Form.Item label={null}>
                                            <Button type="primary" style={{ width: 215, backgroundColor: '#008385', height: 40 }} htmlType="submit" loading={isSubmittingTestEmail} disabled={isSubmittingTestEmail}>
                                                Submit
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                </div>
                            </Card>
                            <Card style={{ width: 460, textAlign: "center", borderRadius: 12, padding: 0 }}>
                                <div style={{ background: "#008385", color: "#fff", padding: "10px", borderRadius: "10px 10px 0 0", margin: 0, fontSize: 18 }}>
                                    Send test SMS
                                </div>
                                <div style={{ marginTop: 20 }}>
                                    <Form
                                        name="basic"
                                        // initialValues={{ remember: true }}
                                        onFinish={onFinishSendTestSms}
                                        onFinishFailed={onFinishFailed}
                                        autoComplete="off"
                                    >
                                        <Row gutter={24}>
                                            <Col span={12}>
                                                <Form.Item
                                                    label={null}
                                                    name="Product"
                                                    rules={[{ required: true, message: 'Product is required' }]}
                                                >
                                                    <Select className="inputbox-custom-placeholder" placeholder="Product" style={{ width: '100%' }}>
                                                        {productCategoryData && productCategoryData.map((item) => {
                                                            return (
                                                                <Option key={item.product_category_id} value={item.product_category_id}>{item.name}</Option>
                                                            )
                                                        })
                                                        }
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item
                                                    label={null}
                                                    name="Clinic"
                                                    rules={[{ required: true, message: 'Username is required' }]}
                                                >
                                                    <Select className="inputbox-custom-placeholder" placeholder="Clinic" style={{ width: '100%' }}>
                                                        {loader == false && allClinicData.data && allClinicData.data.length && allClinicData.data.map((item) => {
                                                            return (
                                                                <Option key={item.id} value={item.id}>{item.name}</Option>
                                                            )
                                                        })
                                                        }
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row gutter={24}>
                                            <Col span={12}>
                                                <Form.Item
                                                    label={null}
                                                    name="date"
                                                    rules={[{ required: true, message: 'date is required' }]}
                                                >
                                                    <DatePicker style={{ width: '100%' }} />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item
                                                    label={null}
                                                    name="time"
                                                    rules={[{ required: true, message: 'Time is required' }]}
                                                >
                                                    <TimePicker style={{ width: '100%' }} />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Form.Item
                                            label={null}
                                            name="phone_number"
                                            rules={[{ required: true, message: 'Mobile number is required' }, {
                                                pattern: /^[0-9]+$/,
                                                message: "Only numeric values are allowed!",
                                            }, {
                                                pattern: /^07\d{9}$/,
                                                message: "Mobile number must be a valid UK mobile (11 digits, start with 07)",
                                            }
                                            ]}
                                        >
                                            <Input placeholder='Mobile number' />
                                        </Form.Item>
                                        <Form.Item label={null}>
                                            <Button type="primary" style={{ width: 215, backgroundColor: '#008385', height: 40 }} htmlType="submit" loading={isSubmittingTestSms} disabled={isSubmittingTestSms}>
                                                Submit
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                </div>
                            </Card>
                        </div>

                        {/* ─── Booking Session Settings ─────────────────────────────────────── */}
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 40, marginBottom: 40 }}>
                            <Card
                                style={{
                                    width: 960,
                                    borderRadius: 16,
                                    boxShadow: '0 4px 24px rgba(0,131,133,0.10)',
                                    overflow: 'hidden',
                                    border: '1px solid #e6f7f7',
                                }}
                                bodyStyle={{ padding: 0 }}
                            >
                                {/* Card Header */}
                                <div style={{
                                    background: 'linear-gradient(135deg, #008385 0%, #005f60 100%)',
                                    color: '#fff',
                                    padding: '16px 24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 10,
                                }}>
                                    <span style={{ fontSize: 18, fontWeight: 600 }}>Booking Session Settings</span>
                                </div>

                                <div style={{ padding: '24px 28px' }}>
                                    <Form
                                        form={sessionForm}
                                        name="booking-session-settings"
                                        onFinish={onFinishSessionSettings}
                                        layout="vertical"
                                        initialValues={sessionConfig}
                                        onValuesChange={(_, all) => setSessionConfig({
                                            duration_minutes: all.duration_minutes ?? sessionConfig.duration_minutes,
                                            warning_before_seconds: all.warning_before_seconds ?? sessionConfig.warning_before_seconds,
                                            extension_minutes: all.extension_minutes ?? sessionConfig.extension_minutes,
                                            max_extensions: all.max_extensions ?? sessionConfig.max_extensions,
                                        })}
                                    >
                                        <Row gutter={[24, 8]}>
                                            {/* Session Duration */}
                                            <Col xs={24} sm={12} lg={6}>
                                                <div style={{
                                                    background: '#fff',
                                                    border: '1px solid #e0f0f0',
                                                    borderRadius: 10,
                                                    padding: '16px 16px 12px',
                                                    height: '100%',
                                                    textAlign: 'center',
                                                }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginBottom: 4 }}>
                                                        <ClockCircleOutlined style={{ color: '#008385', fontSize: 16 }} />
                                                        <span style={{ fontWeight: 600, fontSize: 13, color: '#333' }}>Session Duration</span>
                                                    </div>
                                                    <div style={{ fontSize: 11, color: '#888', marginBottom: 12 }}>Total slot lock time once a slot is selected</div>
                                                    <Form.Item
                                                        name="duration_minutes"
                                                        rules={[{ required: true, message: 'Required' }, { type: 'number', min: 1, max: 60, message: '1–60 minutes' }]}
                                                        style={{ marginBottom: 8 }}
                                                    >
                                                        <InputNumber
                                                            min={1} max={60}
                                                            addonAfter="min"
                                                            style={{ width: '100%' }}
                                                            placeholder="7"
                                                        />
                                                    </Form.Item>
                                                    <Slider
                                                        min={1} max={60}
                                                        className="slider-session"
                                                        value={sessionConfig.duration_minutes}
                                                        onChange={(v) => {
                                                            sessionForm.setFieldsValue({ duration_minutes: v });
                                                            setSessionConfig(prev => ({ ...prev, duration_minutes: v }));
                                                        }}
                                                        styles={{
                                                            track: { backgroundColor: '#008385' },
                                                            handle: { borderColor: '#008385', backgroundColor: '#008385', boxShadow: '0 0 0 2px #008385' },
                                                        }}
                                                        tooltip={{ formatter: (v) => `${v} min` }}
                                                    />
                                                    <div style={{ textAlign: 'center' }}>
                                                        <Tag color="#008385" style={{ fontSize: 13, padding: '2px 12px' }}>
                                                            {sessionConfig.duration_minutes} min
                                                        </Tag>
                                                    </div>
                                                </div>
                                            </Col>

                                            {/* Warning Before Expiry */}
                                            <Col xs={24} sm={12} lg={6}>
                                                <div style={{
                                                    background: '#fff',
                                                    border: '1px solid #fff7e6',
                                                    borderRadius: 10,
                                                    padding: '16px 16px 12px',
                                                    height: '100%',
                                                    textAlign: 'center',
                                                }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginBottom: 4 }}>
                                                        <WarningOutlined style={{ color: '#faad14', fontSize: 16 }} />
                                                        <span style={{ fontWeight: 600, fontSize: 13, color: '#333' }}>Warning Trigger</span>
                                                    </div>
                                                    <div style={{ fontSize: 11, color: '#888', marginBottom: 12 }}>Show popup N seconds before session expires</div>
                                                    <Form.Item
                                                        name="warning_before_seconds"
                                                        rules={[
                                                            { required: true, message: 'Required' },
                                                            { type: 'number', min: 10, max: 300, message: '10–300 seconds' },
                                                            ({ getFieldValue }) => ({
                                                                validator(_, value) {
                                                                    const durationSec = (getFieldValue('duration_minutes') || 1) * 60;
                                                                    const maxWarning = durationSec - 30; // must leave at least 30s gap
                                                                    if (!value || value <= maxWarning) {
                                                                        return Promise.resolve();
                                                                    }
                                                                    return Promise.reject(
                                                                        new Error(`Max ${maxWarning}s — must be at least 30s less than session duration (${durationSec}s)`)
                                                                    );
                                                                },
                                                            }),
                                                        ]}
                                                        style={{ marginBottom: 8 }}
                                                    >
                                                        <InputNumber
                                                            min={10} max={300}
                                                            addonAfter="sec"
                                                            style={{ width: '100%' }}
                                                            placeholder="30"
                                                        />
                                                    </Form.Item>
                                                    <Slider
                                                        min={10} max={300}
                                                        className="slider-warning"
                                                        value={sessionConfig.warning_before_seconds}
                                                        onChange={(v) => {
                                                            sessionForm.setFieldsValue({ warning_before_seconds: v });
                                                            setSessionConfig(prev => ({ ...prev, warning_before_seconds: v }));
                                                        }}
                                                        styles={{
                                                            track: { backgroundColor: '#fa8c16' },
                                                            handle: { borderColor: '#fa8c16', backgroundColor: '#fa8c16', boxShadow: '0 0 0 2px #fa8c16' },
                                                        }}
                                                        tooltip={{ formatter: (v) => `${v}s` }}
                                                    />
                                                    <div style={{ textAlign: 'center' }}>
                                                        <Tag color="warning" style={{ fontSize: 13, padding: '2px 12px' }}>
                                                            {sessionConfig.warning_before_seconds}s before expiry
                                                        </Tag>
                                                    </div>
                                                </div>
                                            </Col>

                                            {/* Extension Duration */}
                                            <Col xs={24} sm={12} lg={6}>
                                                <div style={{
                                                    background: '#fff',
                                                    border: '1px solid #f0ffe6',
                                                    borderRadius: 10,
                                                    padding: '16px 16px 12px',
                                                    height: '100%',
                                                    textAlign: 'center',
                                                }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginBottom: 4 }}>
                                                        <ThunderboltOutlined style={{ color: '#52c41a', fontSize: 16 }} />
                                                        <span style={{ fontWeight: 600, fontSize: 13, color: '#333' }}>Extension Duration</span>
                                                    </div>
                                                    <div style={{ fontSize: 11, color: '#888', marginBottom: 12 }}>Extra time added when user accepts extension</div>
                                                    <Form.Item
                                                        name="extension_minutes"
                                                        rules={[{ required: true, message: 'Required' }, { type: 'number', min: 1, max: 30, message: '1–30 minutes' }]}
                                                        style={{ marginBottom: 8 }}
                                                    >
                                                        <InputNumber
                                                            min={1} max={30}
                                                            addonAfter="min"
                                                            style={{ width: '100%' }}
                                                            placeholder="5"
                                                        />
                                                    </Form.Item>
                                                    <Slider
                                                        min={1} max={30}
                                                        className="slider-extension"
                                                        value={sessionConfig.extension_minutes}
                                                        onChange={(v) => {
                                                            sessionForm.setFieldsValue({ extension_minutes: v });
                                                            setSessionConfig(prev => ({ ...prev, extension_minutes: v }));
                                                        }}
                                                        styles={{
                                                            track: { backgroundColor: '#52c41a' },
                                                            handle: { borderColor: '#52c41a', backgroundColor: '#52c41a', boxShadow: '0 0 0 2px #52c41a' },
                                                        }}
                                                        tooltip={{ formatter: (v) => `${v} min` }}
                                                    />
                                                    <div style={{ textAlign: 'center' }}>
                                                        <Tag color="green" style={{ fontSize: 13, padding: '2px 12px' }}>
                                                            +{sessionConfig.extension_minutes} min per extension
                                                        </Tag>
                                                    </div>
                                                </div>
                                            </Col>

                                            {/* Max Extensions */}
                                            <Col xs={24} sm={12} lg={6}>
                                                <div style={{
                                                    background: '#fff',
                                                    border: '1px solid #f0f0ff',
                                                    borderRadius: 10,
                                                    padding: '16px 16px 12px',
                                                    height: '100%',
                                                    textAlign: 'center',
                                                }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginBottom: 4 }}>
                                                        <CheckCircleOutlined style={{ color: '#722ed1', fontSize: 16 }} />
                                                        <span style={{ fontWeight: 600, fontSize: 13, color: '#333' }}>Max Extensions</span>
                                                    </div>
                                                    <div style={{ fontSize: 11, color: '#888', marginBottom: 12 }}>How many times a user can extend per booking session</div>
                                                    <Form.Item
                                                        name="max_extensions"
                                                        rules={[{ required: true, message: 'Required' }, { type: 'number', min: 1, max: 5, message: '1–5 times' }]}
                                                        style={{ marginBottom: 8 }}
                                                    >
                                                        <InputNumber
                                                            min={1} max={5}
                                                            addonAfter="×"
                                                            style={{ width: '100%' }}
                                                            placeholder="2"
                                                        />
                                                    </Form.Item>
                                                    <Slider
                                                        min={1} max={5}
                                                        dots
                                                        className="slider-maxext"
                                                        value={sessionConfig.max_extensions}
                                                        onChange={(v) => {
                                                            sessionForm.setFieldsValue({ max_extensions: v });
                                                            setSessionConfig(prev => ({ ...prev, max_extensions: v }));
                                                        }}
                                                        styles={{
                                                            track: { backgroundColor: '#722ed1' },
                                                            handle: { borderColor: '#722ed1', backgroundColor: '#722ed1', boxShadow: '0 0 0 2px #722ed1' },
                                                        }}
                                                        tooltip={{ formatter: (v) => `${v}×` }}
                                                    />
                                                    <div style={{ textAlign: 'center' }}>
                                                        <Tag color="purple" style={{ fontSize: 13, padding: '2px 12px' }}>
                                                            {sessionConfig.max_extensions} extension{sessionConfig.max_extensions > 1 ? 's' : ''} allowed
                                                        </Tag>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* Summary + Save Row */}
                                        <div style={{
                                            marginTop: 24,
                                            background: '#f9fefe',
                                            border: '1px solid #d0eeee',
                                            borderRadius: 10,
                                            padding: '14px 20px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            flexWrap: 'wrap',
                                            gap: 12,
                                        }}>
                                            <div style={{ fontSize: 13, color: '#555', lineHeight: '22px' }}>
                                                <strong style={{ color: '#008385' }}>Current config: </strong>
                                                Slot locked for <strong>{sessionConfig.duration_minutes} min</strong> ·
                                                Warning <strong>{sessionConfig.warning_before_seconds}s</strong> before expiry ·
                                                Extend by <strong>{sessionConfig.extension_minutes} min</strong> ·
                                                Max <strong>{sessionConfig.max_extensions}×</strong> extensions
                                            </div>
                                            <Tooltip title={isSubmittingSession ? 'Saving…' : 'Save all session settings'}>
                                                <Button
                                                    type="primary"
                                                    htmlType="submit"
                                                    loading={isSubmittingSession}
                                                    disabled={isSubmittingSession}
                                                    style={{
                                                        backgroundColor: '#008385',
                                                        borderColor: '#008385',
                                                        height: 40,
                                                        minWidth: 160,
                                                        fontWeight: 600,
                                                        borderRadius: 8,
                                                    }}
                                                >
                                                    Save Session Settings
                                                </Button>
                                            </Tooltip>
                                        </div>
                                    </Form>
                                </div>
                            </Card>
                        </div>

                        {/* ─── Patient Email Configuration ───────────────────────────────────── */}
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 40, marginBottom: 40 }}>
                            <Card
                                style={{
                                    width: 960,
                                    borderRadius: 16,
                                    boxShadow: '0 4px 24px rgba(0,131,133,0.10)',
                                    overflow: 'hidden',
                                    border: '1px solid #e6f7f7',
                                }}
                                bodyStyle={{ padding: 0 }}
                            >
                                {/* Card Header */}
                                <div style={{
                                    background: 'linear-gradient(135deg, #008385 0%, #005f60 100%)',
                                    color: '#fff',
                                    padding: '16px 24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    gap: 10,
                                }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                        {/* <MailOutlined style={{ fontSize: 18 }} /> */}
                                        <span style={{ fontSize: 18, fontWeight: 600 }}>Patient Account Setup Email Configuration</span>
                                    </div>

                                </div>
                                <div style={{ padding: '24px 28px' }}>
                                    {!isEditingPatient && (
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 5 }}>
                                            <Button
                                                type="text"
                                                icon={<EditOutlined style={{ fontSize: 18, color: '#008385' }} />}
                                                onClick={() => setIsEditingPatient(true)}
                                            />
                                        </div>
                                    )}
                                    {!isEditingPatient ? (
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                                            <div style={{
                                                background: '#f9fdfd',
                                                border: '1px solid #e0f0f0',
                                                borderRadius: 8,
                                                padding: '12px 16px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 12,
                                            }}>
                                                <span style={{ fontWeight: 600, fontSize: 14, color: '#008385', minWidth: 80 }}>Subject:</span>
                                                <span style={{ fontSize: 14, color: '#333', fontWeight: 500 }}>
                                                    {patientConfig.subject || <span style={{ color: '#aaa', fontStyle: 'italic' }}>No Subject configured</span>}
                                                </span>
                                            </div>

                                            <div>
                                                <div style={{ fontWeight: 600, fontSize: 14, color: '#008385', marginBottom: 8, textAlign: 'justify' }}>Email Content Preview:</div>
                                                <div
                                                    style={{
                                                        background: '#fcfcfc',
                                                        border: '1px solid #e8e8e8',
                                                        borderRadius: 8,
                                                        padding: '24px',
                                                        minHeight: '150px',
                                                        boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.02)',
                                                    }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: patientConfig.body || `<p style="color: #aaa; font-style: italic;">No Content configured</p>`
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <Form
                                            form={patientForm}
                                            name="patient-email-settings"
                                            onFinish={onFinishPatientSettings}
                                            layout="vertical"
                                            initialValues={patientConfig}
                                        >
                                            <Form.Item
                                                label={<span style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>Subject</span>}
                                                name="subject"
                                                rules={[{ required: true, message: 'Subject is required' }]}
                                            >
                                                <Input
                                                    placeholder="Welcome to Your Personal Account!"
                                                    style={{ borderRadius: 8, height: 40 }}
                                                />
                                            </Form.Item>

                                            <Form.Item
                                                label={<span style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>Email Body (HTML)</span>}
                                                name="body"
                                                rules={[{ required: true, message: 'Body is required' }]}
                                            >
                                                <Editor
                                                    apiKey={Config.apiKey}
                                                    onInit={(_evt, editor) => patientEditorRef.current = editor}
                                                    initialValue={patientConfig.body || ''}
                                                    init={{
                                                        height: 300,
                                                        menubar: false,
                                                        plugins: [
                                                            'advlist autolink lists link image charmap print preview anchor',
                                                            'searchreplace visualblocks code fullscreen',
                                                            'insertdatetime media table paste code help wordcount'
                                                        ],
                                                        toolbar: 'undo redo | formatselect | link unlink | customDropdown | ' +
                                                            'bold italic backcolor | alignleft aligncenter ' +
                                                            'alignright alignjustify | bullist numlist outdent indent | ' +
                                                            'removeformat | help',
                                                        setup: (editor) => {
                                                            customDropdown(editor, 'short-codes')
                                                        },
                                                        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                                                        placeholder: "Email body content",
                                                    }}
                                                    onEditorChange={(newContent) => {
                                                        patientForm.setFieldsValue({ body: newContent });
                                                    }}
                                                />
                                            </Form.Item>

                                            {/* Action Buttons Row */}
                                            <div style={{
                                                marginTop: 24,
                                                background: '#f9fefe',
                                                border: '1px solid #d0eeee',
                                                borderRadius: 10,
                                                padding: '14px 20px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'flex-end',
                                                gap: 12,
                                            }}>
                                                <Button
                                                    style={{
                                                        height: 40,
                                                        borderRadius: 8,
                                                        fontWeight: 600,
                                                    }}
                                                    onClick={() => {
                                                        setIsEditingPatient(false);
                                                        patientForm.setFieldsValue(patientConfig);
                                                    }}
                                                >
                                                    Cancel
                                                </Button>
                                                <Tooltip title={isSubmittingPatient ? 'Saving…' : 'Save all patient settings'}>
                                                    <Button
                                                        type="primary"
                                                        htmlType="submit"
                                                        loading={isSubmittingPatient}
                                                        disabled={isSubmittingPatient}
                                                        style={{
                                                            backgroundColor: '#008385',
                                                            borderColor: '#008385',
                                                            height: 40,
                                                            minWidth: 160,
                                                            fontWeight: 600,
                                                            borderRadius: 8,
                                                        }}
                                                    >
                                                        Save Settings
                                                    </Button>
                                                </Tooltip>
                                            </div>
                                        </Form>
                                    )}
                                </div>
                            </Card>
                        </div>
                    </>}
            </div>
        </App>
    )
}

export default Other
